import React from 'react';
import { ProSidebar, Menu, MenuItem, SubMenu, SidebarHeader, SidebarFooter, SidebarContent } from 'react-pro-sidebar';
import styled from 'styled-components';
import { useOnClickOutside } from '../hooks/useOnClickOutside';
import 'react-pro-sidebar/dist/css/styles.css';
import { faGem, faRepeat } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSalesforce } from '@fortawesome/free-brands-svg-icons';
import Logo from '../assets/logo/logo.png'
import NavigationItems, { INavigationItem } from './NFTMarketPlace/data/NavigationItems';
import { useHistory, useLocation } from 'react-router-dom';
import SocialLinks from './NFTMarketPlace/data/SocialLinks';


const SideBarContainer = styled.div`
    .sidebar {
        position: absolute;
        box-shadow: 0px 5px 8px 0px rgba(0,0,0,0.3);
        &.collapsed {
            width: 0;
            min-width: 0;
        }
    }
`;

const Header = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 2rem;
`;

const StyledProSidebar = styled(ProSidebar)`
    color: ${({ theme }) => theme.text2} !important;
    .pro-sidebar-inner {
        background-color: ${({ theme }) => theme.pageBg} !important;
    }
    .pro-inner-list-item {
        background-color: ${({ theme }) => theme.newBg2} !important;
    }
    .pro-menu-item {
        border-left: 3px solid transparent;
        &.active {
            color: ${({ theme }) => theme.yetiBlue} !important;
            border-left: 3px solid ${({ theme }) => theme.yetiBlue};
        }
    }
    .pro-inner-item {
        &:hover,
        &:focus {
            color: ${({ theme }) => theme.text1} !important;
        }
    }
    .pro-icon-wrapper {
        background-color: ${({ theme }) => theme.newBg3} !important;
    }
`;

const Footer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 2rem;
    font-size: 0.8rem;

    > div {
        width: 100%;
        margin-bottom: 1rem;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
`;

export const SocialItem = styled.a`
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    border-radius: 10px;
    margin-right: 10px;
    background-color: #fff;
    color: #393941;
    &:hover {
        box-shadow: ${({ theme }) => theme.boxShadow};
        transform: translateY(-5px);
        transition: all 0.3s ease-in-out;
        cursor: pointer;
    }
`;

const OldUISwitcher = styled.a`
    width: 60px;
    height: 32px;
    display: flex;
    justify-content: flex-start !important;
    align-items: center;
    cursor: pointer;
    font-size: 0.8rem;
    color: ${({ theme }) => theme.text1};
    text-decoration: none;

    .oldUIIcon {
        cursor: pointer;
        margin-right: 5px;
    }
`

const SideBar = (props: any) => {
    const containerRef = React.useRef<HTMLDivElement>(null);

    const onClickOutside = React.useCallback(() => {
        props.onToggle(false);
    }, []);

    useOnClickOutside(containerRef, onClickOutside);

    const navigate = useHistory();
    const location = useLocation();

    const mouseDownHandler = React.useCallback((route: string) => (event: React.MouseEvent) => {
        if (event.button === 1) {
            window.open(route, '_blank');
        }
    }, [])

    const renderMenuItem = (item: INavigationItem) => {
        if (item.subItems) {
            return (
                <SubMenu title={item.name}>
                    {item.subItems.map(renderMenuItem)}
                </SubMenu>
            )
        } else {
            let isActive = location.pathname === item.route;
            return (
                <MenuItem active={isActive} title={item.name} onMouseDown={mouseDownHandler(item.route)} onClick={() => {
                    navigate.push(item.route);
                    props.onToggle(false);
                }}>{item.name}</MenuItem>
            )
        }
    }

    return (
        <SideBarContainer>
            <StyledProSidebar ref={containerRef} collapsedWidth={0} width={300} collapsed={!props.isOpen} className={"sidebar"}>
                <SidebarHeader>
                    <Header>
                        <img width={'50px'} src={Logo} alt="logo" />
                        <h3>NFT MarketPlace</h3>
                    </Header>
                </SidebarHeader>
                <SidebarContent>
                    <Menu iconShape="square">
                        {NavigationItems.map(renderMenuItem)}
                    </Menu>
                </SidebarContent>
                <SidebarFooter>
                    <Footer>
                        <div>
                            {SocialLinks.map(item => (<SocialItem href={item.link} title={item.name}>{item.icon}</SocialItem>))}
                        </div>
                        <div>
                            {`Copyright @ ${new Date().getFullYear()} YetiSwap`}
                        </div>
                    </Footer>
                </SidebarFooter>
            </StyledProSidebar>
        </SideBarContainer>
    )
}

export default SideBar;